import api from "../base-url";
import { mutate } from 'swr';

async function deleteGroups(id: number) {
  try {
    let res = await api.delete(`/groups/${id}`);
    console.log("groups status", res.status);
  
    if(res.status >= 200 && res.status < 300) {
      mutate(`/groups`);
    }
    return res.status;
  } catch (error: any) {
    if (error.response) {
    console.log("error status", error.response.status)
    return error.response.status
  }
}
}

export default deleteGroups;